import { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import classNames from "classnames";
import { useTheme } from "styled-components";

import { EyeIcon2, EyeSlashIcon } from "assets/icons";

export const Input = ({
  label = null,
  helpText = "",
  placeholder = "",
  disabled = false,
  type = "text",
  className,
  ...props
}) => {
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form.Group className={`input-form ${className ? className : ""}`}>
      {(label || helpText) && (
        <div className="d-flex justify-content-between">
          {label && (
            <Form.Label className="input-form-label">{label}</Form.Label>
          )}
          {helpText && <span className="text-muted">{helpText}</span>}
        </div>
      )}

      <Form.Control
        disabled={disabled}
        className={classNames("input-form-field", {
          "padd-right": type === "password",
          "input-form-field-description": type === "textarea",
        })}
        placeholder={placeholder}
        type={showPassword ? "text" : type}
        {...props}
      />
      {type == "password" && (
        <>
          {showPassword && (
            <EyeSlashIcon
              fill={theme.input.icon.color}
              onClick={() => setShowPassword(!showPassword)}
            />
          )}
          {!showPassword && (
            <EyeIcon2 onClick={() => setShowPassword(!showPassword)} />
          )}
        </>
      )}
    </Form.Group>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  helpText: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};
